/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InvalidLegacyRowIssueDto = {
  table: InvalidLegacyRowIssueDto.table;
  name: string;
  /**
   * A state code, or Default for an Echo row
   */
  state: string;
  reason: string;
};
export namespace InvalidLegacyRowIssueDto {
  export enum table {
    CARRIER_INFO = 'carrier_info',
    MAJOR_MEDICAL_CARRIER = 'major_medical_carrier',
  }
}
